export default __webpack_public_path__ + "images/0xf97f4df75117a78c1a5a0dbb814af92458539fb4.png";